import React from 'react';

import {theme} from '../constants';
import {Header} from './Header';
import {TabLoader} from './TabLoader';
import {ScrollToTop} from './ScrollToTop';
import {BottomTabBar} from '../navigation/BottomTabBar';

type Props = {
  title: string;
  children: React.ReactNode;
  loading?: boolean;
  contentPaddingTop?: number;
  contentPaddingBottom?: number;
};

export const TabScaffold: React.FC<Props> = ({
  title,
  children,
  loading = false,
  contentPaddingTop = 16,
  contentPaddingBottom = 120,
}) => {
  return (
    <div id='screen'>
      <ScrollToTop />
      <Header title={title} line={true} />

      <main
        style={{
          marginTop: 56,
          paddingBottom: contentPaddingBottom,
          backgroundColor: theme.colors.ghostWhite,
          minHeight: 'calc(100vh - 56px)',
        }}
      >
        <div className='container' style={{paddingTop: contentPaddingTop}}>
          {loading ? <TabLoader /> : children}
        </div>
      </main>

      <BottomTabBar />
    </div>
  );
};
